(function () {
  function initSection(root) {
    if (!root || root.dataset.yhClearanceInit === 'true') return;

    var track = root.querySelector('[data-yh-clearance-track]');
    if (!track) return;

    root.dataset.yhClearanceInit = 'true';

    var cards = Array.from(root.querySelectorAll('.clearance-deals__slide'));
    var prevBtn = root.querySelector('[data-yh-clearance-prev]');
    var nextBtn = root.querySelector('[data-yh-clearance-next]');
    var nav = root.querySelector('[data-yh-clearance-nav]');

    if (nav && cards.length <= 1) {
      nav.style.display = 'none';
    }

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth;
      if (nav) nav.style.display = max <= 1 ? 'none' : '';
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function scrollByCard(direction) {
      var card = cards[0];
      if (!card) return;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    updateNav();

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateNav);
    });

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button, a')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = scrollLeft - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-yh-clearance]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var section = event.target.querySelector('[data-yh-clearance]') || event.target;
    if (section && section.matches && section.matches('[data-yh-clearance]')) {
      section.dataset.yhClearanceInit = '';
      initSection(section);
    } else {
      initAll(event.target);
    }
  });
})();
